<template>
  <div class="signup-button">
      <router-link :to="`/leagues/signup/${season.id}`" type="button" class="button is-primary is-inverted is-outlined is-rounded">Signup</router-link>
  </div>
</template>

<script>
export default {
  name: 'SignupButton',
  computed: {
    season() {
      // Relies on the fact that an upcoming season shouldn't be created until after
      // registration for the current season has closed
      return this.$store.state.upcomingSeason || this.$store.state.currentSeason;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>